import styled from "styled-components"
import { ContentWrapper as GlobalContentWrapper } from "../../ui/content-wrapper/content-wrapper-elements"
import {
  SectionWrapperStyles,
  ContentWrapperStyles,
  LeftColStyles,
  RightColStyles,
} from "./slider-with-widgets-styles"
import { BreakPoints, media } from "../../helpers/rwd"

export const SectionWrapper = styled.section`
  padding: 60px 0;
  ${SectionWrapperStyles}
`

export const ContentWrapper = styled(GlobalContentWrapper)`
  display: flex;
  justify-content: space-between;
  ${media.max(BreakPoints.desktop)} {
    flex-direction: column;
  }
  ${ContentWrapperStyles}
`

export const LeftCol = styled.div`
  width: 100%;
  max-width: calc(100% - 322px - 30px);
  ${media.max(BreakPoints.desktop)} {
    max-width: none;
  }
  ${LeftColStyles}
`

export const RightCol = styled.div`
  width: 100%;
  max-width: 322px;
  ${media.max(BreakPoints.desktop)} {
    max-width: none;
  }
  ${RightColStyles}
`
